import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BaseState, Button } from '@airclou/ui'
import { FileQuestion } from 'lucide-react'

/**
 * Real destination for unmatched routes.
 *
 * The catch-all used to render `OverviewPage`, which made every broken link in
 * the app look like a working link to the home page — that is how the profile
 * menu's `/support` entry stayed dead without anyone noticing.
 *
 * Built on `BaseState` rather than `ErrorState`: a mistyped URL is not a
 * failure to alarm about, so it takes the neutral muted-gray icon treatment
 * (BaseState's default) instead of ErrorState's orange warning tint. Matches
 * the Knowledgebase portal's 404. `EmptyState` would read wrong here — the
 * page isn't empty, it doesn't exist.
 */
export function NotFoundPage() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation('dashboard')

  // No padding wrapper: BaseState already carries `py-12` internally and the
  // layout's content area adds `p-8`. Every other dashboard caller renders it
  // bare for the same reason.
  return (
    <BaseState
      icon={FileQuestion}
      title={t('notFound.title')}
      description={t('notFound.description', { path: pathname })}
      action={<Button onClick={() => navigate('/')}>{t('notFound.goToOverview')}</Button>}
    />
  )
}
